import * as React from 'react';
import NumberView, { Props as NumberViewProps } from 'shared/components/NumberView';

interface Props extends NumberViewProps {
  className?: string;
  sign?: boolean;
  children: number | null;
}

const PercentView: React.FC<Props> = (props) => (
  <NumberView unit="%" hideZeroFraction maximumFractionDigits={2} {...props} />
);

export default PercentView;
